module.exports = __webpack_public_path__ + "assets/oil-life.2193604c.svg";